<template>
  <div style="flex: 1;height: 1px;display: flex;flex-direction: column;margin: 0px 0 10px 0;">
    <div style="height: 100%;width: 100%; border: 1px solid rgba(43, 143, 222, 1);
            position: relative;
            box-sizing: border-box;display: flex;">
      <template v-if="simList.length">
        <!-- 目录-->
        <div style="
                  width: 150px;
                  background-color: #d6deee;
                  padding: 10px;
                  display: flex;
                  flex-direction: column;
                  box-sizing: border-box;
                  border-right: 1px solid rgba(163, 188, 208, 1);
                ">
          <div
              style="
                    font-weight: 700;
                    font-style: normal;
                    font-size: 14px;
                    color: #333333;
                    height: 33px;
                    line-height: 33px;
                    text-align: center;
                  "
          >
            目录
          </div>
          <div
              ref="muluContainer"
              style="flex: 1; background: #fff; overflow: auto"
          >
            <el-collapse v-model="activeGroupIdx" accordion>
              <template v-for="(item, idx) in showGroupSims">
                <el-collapse-item :key="idx" :name="idx">
                  <template slot="title">
                    <p v-if="item.category === 0" class="catalogue_title">{{ `投标异常组${idx + 1}` }}</p>
                    <p v-else class="catalogue_title">{{ `招标相似组${idx + 1}` }}</p>
                  </template>
                  <template v-for="_item in item.pictures_sims">
                    <p :key="_item.index"
                       :class="{
                               active_catalogue_item: _item.index == currentIdx
                             }"
                       class="catalogue_item"
                       @click="changeCatalog(_item)"
                    >{{ `${item.category == 1 ? '相似项' : '异常项'}${_item.index + 1}` }}</p>
                  </template>
                </el-collapse-item>
              </template>
            </el-collapse>
          </div>
        </div>
        <div style="flex:1; width: 1px;
                  border-right: 1px solid rgba(43, 143, 222, 1);
                  display: flex;
                  flex-direction: column;">
          <div class="pdfTitle">
            【{{ currentItem.name }}】- {{ currentItem.mulu }}
          </div>
          <div
              style="flex:1;height: 1px;display: flex;justify-content: center;align-items: center;"
          >
            <img :src="baseUrl" alt="" style="max-height: 100%;max-width: 100%;">
          </div>
        </div>
        <div style="width: 100px;display: flex;flex-direction: column;align-items: center;justify-content: center;">
          <img src="@/assets/image/imageSimilar.png" alt="">
          <span style="color: #1D2129;font-size: 20px;font-weight: bold;">{{currentItem.sim_rate}}</span>
          <span>相似度</span>
        </div>
        <div style="flex:1; width: 1px;
                  border-left: 1px solid rgba(43, 143, 222, 1);
                  display: flex;
                  flex-direction: column;">
          <div class="pdfTitle">
            【{{ currentItem.cont_name }}】- {{ currentItem.cont_mulu }}
          </div>
          <div
              style="flex:1;height: 1px;display: flex;justify-content: center;align-items: center;"
          >
            <img :src="contUrl" alt="" style="max-height: 100%;max-width: 100%;">
          </div>
        </div>
      </template>
      <template v-else>
        <div style="width: 100%;height: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;">
          <img alt=""  src="@/assets/image/e1.png"/>
          <div
              style="
                  font-weight: 400;
                  font-style: normal;
                  font-size: 14px;
                  color: rgb(85, 85, 85);
                  margin-top: 10px;
                  line-height: 28px;
                  height: 28px;
                  text-align: center;
                "
          >
            没有异常相似哦~
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {getSimilarPic} from "@/api/pdf";
import {mapState} from "vuex";

export default {
  name: "imgCmp",
  props: {
    companyData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      simList: [],
      groupSims: [],
      currentGroupId: 0,
      activeGroupIdx: 0,
      currentIdx: '',
      currentItem: null,
      baseUrl: "",
      contUrl: "",
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const self = this;
      this.groupSims = this.companyData.details;
      this.groupSims = this.$_.filter(this.groupSims, (item) => {
        return item.pictures_sims.length !== 0
      });

      this.simList = [];
      this.$_.each(this.groupSims, (item, idx) => {
        item.groupId = idx;
        this.$_.each(item.pictures_sims, (_item, _idx) => {
          _item.cont_name = item.cont_name;
          _item.name = item.name;
          _item.file = item.file
          _item.mulu = item.mulu
          _item.cont_mulu = item.cont_mulu
          _item.cont_file = item.cont_file
          _item.groupId = idx
          _item.category = item.category
        });
        this.simList = this.simList.concat(item.pictures_sims);
        this.$_.each(this.simList, (item, idx) => {
          item.index = idx;
        });

      })
      // 默认取第一个异常
      this.currentIdx = 0;
      this.currentItem = this.$_.find(this.simList, function (item) {
        return item.index === self.currentIdx
      })
      if (this.currentItem) {
        this.activeGroupIdx = this.currentItem.groupId
        this.changeCatalog(this.currentItem)
      }
    },
    async changeCatalog(item) {
      this.currentIdx = item.index;
      this.currentGroupId = item.groupId;


      let base = await this.getSimilarPic(item.file, item.pic_name);
      let cont = await this.getSimilarPic(item.cont_file, item.o_pic_name);
      this.baseUrl = base.url ? base.url : "";
      this.contUrl = cont.url ? cont.url : "";


    },
    async getSimilarPic(file, pic) {
      let res = await getSimilarPic({
        project: this.projectId,
        sign_name: this.sign_name,
        file: file,
        pic_name: pic
      });
      return res.data;
    },
  },
  computed: {
    ...mapState('pdf', ['projectId', 'sign_name']),
    showGroupSims() {
      const temp = this.$_.filter(this.groupSims, (item) => {
        return item.pictures_sims.length !== 0
      })
      return temp
    }
  },
  watch: {
    companyData(val) {
      this.init();
    }
  }

}
</script>

<style lang="scss" scoped>
.noSimContainer {
  width: 320px;
  height: 180px;
  position: absolute;
  top: calc(50% - 90px);
  left: calc(50% - 160px);

  .noSim_img {
    width: 320px;
    height: 152px;
    display: block;
    margin: 0 auto;
  }
}

.sim_tip_text {
  font-weight: 700;
  font-style: normal;
  font-size: 12px;
  color: #333;
}

.table {
  width: 800px;
  margin-left: 16px;
  margin-top: 10px;
}

.red {
  color: #d9001b;
}

.green {
  color: #13b002;
}

.catalogue_item {
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin-top: 5px;
  cursor: pointer;
  font-size: 13px;
  position: relative;
}

.catalogue_title {
  height: 30px;
  line-height: 30px;
  text-align: center;
  // margin-top: 5px;
  font-size: 13px;
  position: relative;
  background-color: #f6f6f6;
  flex: 1;

}

.active_catalogue_item {
  background-color: #d6deee;
  font-weight: 700;
  font-style: normal;
  font-size: 13px;
  color: #000;
  position: relative;

  &::after {
    content: "";

    display: block;
    width: 5px;
    height: 30px;
    background-color: #d6deee;
    position: absolute;
    left: 0;
    top: 0;
  }
}

.pdfTitle {
  height: 43px;
  border-bottom: 1px solid rgba(163, 188, 208, 1);
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  line-height: 43px;
  text-align: center;
}

.simModel {
  border-radius: 5px;
}

.sim_active {
  border: 2px solid #ff5d3f;
}

.simModel_tag {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  //background: rgba(217, 0, 27, 0.2);
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  margin-bottom: 5px;
  cursor: pointer;

}

.simModel_tag_active1 {
  background: #d9001b !important;

}

.simModel_tag_active2 {
  background: #c8c823 !important;

}

.sim_active1 {
  border: 2px solid #d9001b;
}

.sim_active2 {
  border: 2px solid #c8c823;
}
</style>
